import type { DynamicClient } from '../../../client/types';
import { getWalletProviderRegistry } from '../walletProviderRegistry';

/**
 * Get all available wallet providers to interact with internally.
  * @notInstrumented
 */
export const getWalletProviders = (client: DynamicClient) => {
  const walletProviderRegistry = getWalletProviderRegistry(client);

  return walletProviderRegistry.listProviders();
};
